import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import { withRouter } from 'next/router'
import { Container, Row, Col } from 'react-awesome-styled-grid'
import type { AppStateType } from '../reducers/appstate'
import HtmlHead from '../components/HtmlHead'
import { H1, H2, H3, H4, H5, P, Quote, GlobalStyle } from '../components/shared'
import { CTAPrimary, CTASecondary } from '../components/shared/buttons'
import { colors } from '../components/shared/colors'
import { DipseaLogo, DipseaBrandmark } from '../components/shared/icons'
import { ValueProp } from '../components/ValueProp'
import { InputWithApplyCta } from '../components/PromoCode/InputWithApplyCta'
import { PromoApplied } from '../components/PromoCode/PromoApplied'
import TopNav from '../components/TopNav'
import Footer from '../components/Footer'

function StyleBook (): React.ReactNode {
  return (
    <>
      <HtmlHead title={'Dipsea Stylebook'} />
      <GlobalStyle backgroundColor={colors.midnightBlue} />
      <TopNav backgroundColor={colors.midnightBlue90}/>

      <Container>
        <SectionHeader text='Typography' />
        <Row>
          <Col>
            <H1>H1: Let us tell you a sexy story.</H1>
            <H2>H2: Listen, light yourself up. </H2>
            <H3>H3: Everyone’s into something. Discover stories for you. </H3>
            <H4>H4: Why would you give someone sexy audio stories?. </H4>
            <H5>H5: Wild Hearts II. </H5>
            <Quote>Quote: I had this amazing feeling of my sexuality being respected and catered to, that I hadn't really identified as a void until I felt it fulfilled for the first time.</Quote>
            <P>P: King Princess wants to change the world her own way and we’re here for all of it. After one watch of video for her song “Talia,” an aching breakup ode where she imagines her lover still beside her, and you’ll get why we had to team up and invite her young queer perspective into the Dipsea universe.  </P>
          </Col>
        </Row>

        <SectionHeader text='Primary Buttons' />
        <Row>
          <Col xs={4} sm={8} md={4} lg={3}>
            <CTAPrimary>CTAPrimary: Orange</CTAPrimary>
          </Col>
          <Col xs={4} sm={8} md={4} lg={3}>
            <CTAPrimary margin={'12px 0px 12px 0px'} color={colors.white} backgroundColor={colors.black}>CTAPrimary: Black</CTAPrimary>
          </Col>
          <Col xs={4} sm={8} md={4} lg={3}>
            <CTAPrimary color={colors.white} backgroundColor={colors.blue}>CTAPrimary: Blue</CTAPrimary>
          </Col>
        </Row>

        <SectionHeader text='Secondary Buttons' />
        <Row style={{ backgroundColor: colors.orange }}>
          <Col xs={4} sm={8} md={4} lg={3}>
            <CTASecondary margin={'12px 0px 12px 0px'}>CTASecondary: Orange</CTASecondary>
          </Col>
        </Row>
        <Row style={{ backgroundColor: colors.blue }}>
          <Col xs={4} sm={8} md={4} lg={3}>
            <CTASecondary margin={'12px 0px 12px 0px'} backgroundColor={colors.blue}>CTASecondary: blue</CTASecondary>
          </Col>
        </Row>

        <SectionHeader text='DipseaLogo' />
        <Row style={{ backgroundColor: colors.cobalt }}>
          <Col>
            <DipseaLogo />
          </Col>
        </Row>

        <SectionHeader text='DipseaBrandmark' />
        <Row style={{ backgroundColor: colors.midnightBlue }}>
          <Col>
            <DipseaBrandmark />
          </Col>
        </Row>
      </Container>

      <Container style={{ backgroundColor: colors.creamsicle }}>
        <SectionHeader text='ValueProp' />
        <Row>
          <Col xs={12} md={6} >
            <ValueProp text="This is a value prop" />
            <ValueProp text="This is another value prop that is very long and will wrap into the next line" />
          </Col>
        </Row>
      </Container>

      <Container style={{ backgroundColor: colors.orange }}>
        <SectionHeader text='Promo' />
        <Row>
          <Col xs={12} md={6} >
            <form id="subscribe-promo" onSubmit={(_event: React.ChangeEvent<any>): void => alert('Hello')} />

            <P color={colors.black} fontSize='14px' margin='0 0 10px'>InputWithApplyCta: Never touched state</P>
            <InputWithApplyCta
              formId="subscribe-promo"
              name="promo-code"
              placeholder="Promo Code"
              value={''}
              onChange={(event: React.ChangeEvent<any>): void => {
                alert(event.target.value) // save value to state and clear error message
              }}
              onClickApply={(event: React.ChangeEvent<any>): void => {
                event.preventDefault()
                alert('Clicked Apply')
              }}
            />

            <P color={colors.black} fontSize='14px' margin='10px 0'>InputWithApplyCta: Active state</P>
            <InputWithApplyCta
              formId="subscribe-promo"
              name="promo-code"
              placeholder="Promo Code"
              value={'Hello'}
              onChange={(event: React.ChangeEvent<any>): void => {
                alert(event.target.value) // save value to state and clear error message
              }}
              onClickApply={(event: React.ChangeEvent<any>): void => {
                event.preventDefault()
                alert('Clicked Apply')
              }}
            />

            <P color={colors.black} fontSize='14px' margin='10px 0'>InputWithApplyCta: Error state</P>
            <InputWithApplyCta
              formId="subscribe-promo"
              name="promo-code"
              placeholder="Promo Code"
              value={'Hello'}
              onChange={(event: React.ChangeEvent<any>): void => {
                alert(event.target.value) // save value to state and clear error message
              }}
              onClickApply={(event: React.ChangeEvent<any>): void => {
                event.preventDefault()
                alert('Clicked Apply')
              }}
              errorMessage={'Enter a valid promo code '}
            />

            <P color={colors.black} fontSize='14px' margin='10px 0'>PromoApplied: Redeemed state</P>
            <PromoApplied promoCode='HARVARD' />
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  )
}

const SectionHeader = (props: { text: string }): React.ReactNode => {
  return (
    <Row>
      <Col xs={12}>
        <H3 style={{ marginBottom: 15, marginTop: 30 }}>{props.text}</H3>
      </Col>
    </Row>
  )
}

const mapStateToProps = (_state: AppStateType): any => {
  return {
  }
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StyleBook) as any) as any
